package com.evoapps.evoshift.ui.roster

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.monthInSentence
import androidx.compose.material3.TextButton
import androidx.compose.runtime.LaunchedEffect
import com.evoapps.evoshift.domain.usecase.todo.RosterStage
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayAndMonth
import evoshift.composeapp.generated.resources.capacity_reminder_message
import evoshift.composeapp.generated.resources.capacity_reminder_message_due
import evoshift.composeapp.generated.resources.capacity_reminder_title

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import evoshift.composeapp.generated.resources.roster_card_capacity_action
import evoshift.composeapp.generated.resources.roster_card_capacity_title
import evoshift.composeapp.generated.resources.roster_more_actions
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.DropdownMenu
import androidx.compose.material.icons.filled.MoreVert
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import evoshift.composeapp.generated.resources.nav_rosters
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows

import com.evoapps.evoshift.widgets.LocalContextSwitcher
import com.evoapps.evoshift.widgets.parseIsoDate
import com.evoapps.evoshift.widgets.parseClockTime
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.domain.capacity.monthRange
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.EvoDateRangeField
import com.evoapps.evoshift.widgets.MissingYear
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogAction
import kotlinx.datetime.plus
import kotlinx.datetime.minus
import kotlinx.datetime.LocalDate
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.number
import androidx.compose.ui.platform.testTag
import com.evoapps.evoshift.domain.util.AppClock
import evoshift.composeapp.generated.resources.roster_empty_create
import evoshift.composeapp.generated.resources.roster_empty_step_availability
import evoshift.composeapp.generated.resources.roster_empty_step_demand
import evoshift.composeapp.generated.resources.roster_empty_step_publish
import evoshift.composeapp.generated.resources.roster_empty_steps_title
import evoshift.composeapp.generated.resources.roster_skeleton_open_finish
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.ui.text.style.TextAlign
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.widgets.LocalOnColours
import com.evoapps.evoshift.domain.usecase.todo.AvailabilityStep
import evoshift.composeapp.generated.resources.availability_any_month_hint
import evoshift.composeapp.generated.resources.availability_any_month_title
import evoshift.composeapp.generated.resources.availability_month
import evoshift.composeapp.generated.resources.availability_month_closed
import evoshift.composeapp.generated.resources.availability_month_no_roster
import evoshift.composeapp.generated.resources.roster_previous_month
import evoshift.composeapp.generated.resources.roster_next_month
import com.evoapps.evoshift.ui.notifications.NotificationsBell
import evoshift.composeapp.generated.resources.workplace
import com.evoapps.evoshift.ui.util.label
import com.evoapps.evoshift.ui.util.monthName
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.roster_delete
import evoshift.composeapp.generated.resources.roster_delete_confirm
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.rememberEndKeepingGridState
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.EditCalendar
import androidx.compose.material.icons.filled.EventAvailable
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.filled.Layers
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.role
import androidx.compose.ui.semantics.semantics
import com.evoapps.evoshift.ui.adaptive.cardClickable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.model.RosterStatus
import com.evoapps.evoshift.domain.model.AvailabilityEmailLinks
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoRadioGroup
import evoshift.composeapp.generated.resources.availability_email_also
import evoshift.composeapp.generated.resources.availability_email_everyone
import evoshift.composeapp.generated.resources.availability_email_hint
import evoshift.composeapp.generated.resources.availability_email_without_app
import evoshift.composeapp.generated.resources.roster_status_skeleton_hint
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.DashboardEvent
import com.evoapps.evoshift.viewmodels.DashboardViewModel
import com.evoapps.evoshift.widgets.LoadingOverlay
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.availability_deadline
import evoshift.composeapp.generated.resources.capacity_title
import evoshift.composeapp.generated.resources.availability_default_message
import evoshift.composeapp.generated.resources.availability_due_date
import evoshift.composeapp.generated.resources.availability_end_date
import evoshift.composeapp.generated.resources.availability_message
import evoshift.composeapp.generated.resources.availability_planning_period
import evoshift.composeapp.generated.resources.availability_save_changes
import evoshift.composeapp.generated.resources.availability_send_request
import evoshift.composeapp.generated.resources.availability_start_date
import evoshift.composeapp.generated.resources.availability_time
import evoshift.composeapp.generated.resources.dashboard_change_availability_request
import evoshift.composeapp.generated.resources.dashboard_define_patterns
import evoshift.composeapp.generated.resources.dashboard_new_roster
import evoshift.composeapp.generated.resources.dashboard_no_rosters
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_recent_rosters
import evoshift.composeapp.generated.resources.dashboard_request_availability
import evoshift.composeapp.generated.resources.dashboard_roster_blueprints
import evoshift.composeapp.generated.resources.dashboard_select_workplace
import evoshift.composeapp.generated.resources.dashboard_switch
import evoshift.composeapp.generated.resources.dashboard_weekly_skeleton
import evoshift.composeapp.generated.resources.dashboard_workplace_fallback
import kotlinx.datetime.Month
import org.jetbrains.compose.resources.stringResource
import androidx.compose.material.icons.automirrored.filled.OpenInNew
import com.evoapps.evoshift.shell.WindowTarget
import com.evoapps.evoshift.shell.rememberOpenInNewWindow
import com.evoapps.evoshift.widgets.ContextMenuArea
import com.evoapps.evoshift.widgets.ContextMenuItem
import evoshift.composeapp.generated.resources.open_in_new_window
import com.evoapps.evoshift.widgets.MessageEffect

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RosterManagementScreen(
    viewModel: DashboardViewModel,
    onCreateNewRoster: (String, String) -> Unit,
    onRosterSelected: (Roster) -> Unit,
    onSkeletonEditorSelected: (String) -> Unit,
    onNavigateToProfile: () -> Unit,
    onCreateNewWorkplaceClicked: () -> Unit,
    onNavigateToWorkplaceSettings: (String) -> Unit,
    /** The month's capacity before planning (SH-48). */
    onOpenCapacity: (Roster) -> Unit = {},
    /** SH-167: "Create the roster for November 2026": the create screen on that month. */
    onCreateRosterForMonth: (workplaceId: String, workplaceName: String, year: Int, month: Int) -> Unit = { wp, name, _, _ -> onCreateNewRoster(wp, name) },
    /** SH-170: the cards' four-step trackers; null: none. */
    tracker: com.evoapps.evoshift.viewmodels.RosterTrackerViewModel? = null,
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val trackerState = tracker?.uiState?.collectAsStateWithLifecycle()?.value ?: com.evoapps.evoshift.viewmodels.RosterTrackerUiState()
    // Back on the list (after building a month): the numbers are read again.
    LaunchedEffect(tracker) { tracker?.refresh() }
    // What a reminder did ("Wysłane przypomnienia: 3").
    val trackerSnackbar = remember { androidx.compose.material3.SnackbarHostState() }
    MessageEffect(trackerState.message, trackerSnackbar, onShown = { tracker?.messageShown() })
    // SH-172: the availability request went (or why it did not); SH-188: a month was deleted.
    MessageEffect(state.notice, trackerSnackbar, onShown = { viewModel.onEvent(DashboardEvent.NoticeShown) })
    val contextSwitcher = LocalContextSwitcher.current
    val openInNewWindow = rememberOpenInNewWindow()
    val newWindowLabel = stringResource(Res.string.open_in_new_window)
    var rosterToRequestAvailability by remember { mutableStateOf<Roster?>(null) }
    var requestForMonth by remember { mutableStateOf(false) }
    var rosterToDelete by remember { mutableStateOf<Roster?>(null) }


    rosterToDelete?.let { roster ->
        EvoConfirmDialog(
            title = stringResource(Res.string.roster_delete),
            text = stringResource(Res.string.roster_delete_confirm),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = {
                viewModel.onEvent(DashboardEvent.DeleteRoster(roster.id))
                rosterToDelete = null
            },
            onDismiss = { rosterToDelete = null },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }

    rosterToRequestAvailability?.let { roster ->
        AvailabilityRequestDialog(
            roster = roster,
            onDismiss = { rosterToRequestAvailability = null },
            onConfirm = { startDate, endDate, dueDate, message, emailLinks ->
                val monthStr = roster.month.toString().padStart(2, '0')
                viewModel.onEvent(
                    DashboardEvent.RequestAvailability(
                        rosterId = roster.id,
                        month = "${roster.year}-${monthStr}",
                        startDate = startDate,
                        endDate = endDate,
                        dueDate = dueDate,
                        message = message ?: "",
                        emailLinks = emailLinks
                    )
                )
                rosterToRequestAvailability = null
            }
        )
    }

    val requestWorkplace = state.currentWorkplaceId
    if (requestForMonth && requestWorkplace != null) {
        MonthAvailabilityRequestDialog(
            workplaceId = requestWorkplace,
            rosters = state.activeRosters,
            onDismiss = { requestForMonth = false },
            onConfirm = { year, month, startDate, endDate, dueDate, message, emailLinks ->
                viewModel.onEvent(DashboardEvent.RequestAvailabilityForMonth(year, month, startDate, endDate, dueDate, message, emailLinks))
                requestForMonth = false
            }
        )
    }

    Scaffold(
        containerColor = Cream,
        snackbarHost = { androidx.compose.material3.SnackbarHost(trackerSnackbar) },
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.nav_rosters),
                showWorkplace = true,
                actions = listOf(
                    helpAction(HelpPage.ROSTERS),
                    notificationsAction(),
                    TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false)
                )
            )
        },
        floatingActionButton = {
            state.currentWorkplaceId?.takeIf { state.capabilities.shows(Gate.ROSTER_EDITING) }?.let { wpId ->
                val fallbackName = stringResource(Res.string.workplace)
                Box(
                    modifier = Modifier
                        .size(64.dp)
                        .clip(CircleShape)
                        .background(GoldMetallicBrush)
                        .handCursor()
                        .clickable {
                            val wpName = state.availableWorkplaceIds[wpId] ?: fallbackName
                            onCreateNewRoster(wpId, wpName)
                        },
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        Icons.Default.Add,
                        stringResource(Res.string.dashboard_new_roster),
                        modifier = Modifier.size(32.dp),
                        tint = DeepNavy
                    )
                }
            }
        }
    ) { padding ->
        // SH-168: pulling down reads the rosters again (also after they failed to load).
        PullToRefreshBox(
            isRefreshing = state.isRefreshing,
            onRefresh = { viewModel.onEvent(DashboardEvent.Refresh) },
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            // One column on phones; on tablets and desktops the months fill two or three columns,
            // with the section headers across the full width.
            // SH-201: keys for every item, not only the months, so the list keeps its place by the
            // item it shows when items before it come or go; at its end it stays at the end.
            AdaptiveCardGrid(
                state = rememberEndKeepingGridState(),
                contentPadding = PaddingValues(16.dp),
                spacing = 16.dp,
                maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
            ) {
                if (state.capabilities.shows(Gate.ROSTER_EDITING)) item(key = "blueprints-header", span = { GridItemSpan(maxLineSpan) }) {
                    Text(
                        stringResource(Res.string.dashboard_roster_blueprints),
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = DeepNavy,
                        modifier = Modifier.padding(bottom = 8.dp)
                    )
                }

                // The weekly blueprint is roster building: only for those who build rosters.
                if (state.capabilities.shows(Gate.ROSTER_EDITING)) item(key = "weekly-skeleton") {
                    RegularCard(
                        modifier = Modifier.hoverLift(),
                        onClick = { state.currentWorkplaceId?.let { onSkeletonEditorSelected(it) } }
                    ) {
                        Row(
                            modifier = Modifier.padding(16.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(40.dp)
                                    .clip(RoundedCornerShape(8.dp))
                                    .background(DeepNavy),
                                contentAlignment = Alignment.Center
                            ) {
                                Icon(Icons.Default.Layers, null, tint = Color.White)
                            }
                            Spacer(Modifier.width(16.dp))
                            Column(modifier = Modifier.weight(1f)) {
                                Text(
                                    stringResource(Res.string.dashboard_weekly_skeleton),
                                    style = MaterialTheme.typography.titleMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = DeepNavy
                                )
                                Text(
                                    stringResource(Res.string.dashboard_define_patterns),
                                    style = MaterialTheme.typography.bodySmall,
                                    color = DeepNavy.copy(alpha = 0.7f)
                                )
                            }
                            Icon(Icons.Default.ChevronRight, null, tint = DeepNavy)
                        }
                    }
                }

                item(key = "recent-header", span = { GridItemSpan(maxLineSpan) }) {
                    Column {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            stringResource(Res.string.dashboard_recent_rosters),
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold,
                            color = DeepNavy,
                            modifier = Modifier.padding(bottom = 8.dp)
                        )
                    }
                }

                // SH-172: availability for any month, also one without a roster (an empty one is made).
                if (state.capabilities.shows(Gate.AVAILABILITY_CAMPAIGN) && viewModel.canRequestForAnyMonth && state.currentWorkplaceId != null) {
                    item(key = "availability-any-month", span = { GridItemSpan(maxLineSpan) }) {
                        // SH-209: a card row (the hover tint, the keyboard focus ring), not a Material
                        // Button: its focus state layer stayed grey after a click on the web.
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .cardClickable(RoundedCornerShape(8.dp)) { requestForMonth = true }
                                .semantics { role = Role.Button }
                                .testTag(AvailabilityMonthTags.ENTRY)
                                .background(DeepNavy.copy(alpha = 0.05f))
                                .padding(horizontal = 16.dp, vertical = 10.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(Icons.Default.EventAvailable, null, modifier = Modifier.size(20.dp), tint = DeepNavy)
                            Spacer(Modifier.width(12.dp))
                            Column(Modifier.weight(1f)) {
                                Text(stringResource(Res.string.availability_any_month_title), style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold, color = DeepNavy)
                                Text(
                                    stringResource(Res.string.availability_any_month_hint),
                                    style = MaterialTheme.typography.bodySmall,
                                    color = DeepNavy.copy(alpha = 0.75f)
                                )
                            }
                            Icon(Icons.Default.ChevronRight, null, modifier = Modifier.size(20.dp), tint = DeepNavy)
                        }
                    }
                }

                val rostersLoadError = state.rostersLoadError
                if (state.activeRosters.isEmpty() && rostersLoadError != null) {
                    // SH-168: the rosters could not be read: not "no rosters yet", Try again.
                    item(key = "load-error", span = { GridItemSpan(maxLineSpan) }) {
                        com.evoapps.evoshift.widgets.ErrorState(rostersLoadError, onRetry = { viewModel.onEvent(DashboardEvent.Refresh) })
                    }
                } else if (!state.rostersKnown) {
                    // SH-247: the months are on their way: their cards' shapes, not "no rosters yet".
                    items(ROSTER_PLACEHOLDERS, key = { "placeholder-$it" }) {
                        Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                            com.evoapps.evoshift.widgets.SkeletonArea {
                                com.evoapps.evoshift.widgets.SkeletonRowCard(leadingShape = RoundedCornerShape(8.dp))
                            }
                        }
                    }
                } else if (state.activeRosters.isEmpty()) {
                    item(key = "empty", span = { GridItemSpan(maxLineSpan) }) {
                        val workplaceId = state.currentWorkplaceId?.takeIf { state.capabilities.shows(Gate.ROSTER_EDITING) && !state.isLoadingRosters }
                        val fallbackName = stringResource(Res.string.workplace)
                        EmptyRosters(
                            next = remember(state.activeRosters) { nextMonthWithoutRoster(state.activeRosters) },
                            onCreate = workplaceId?.let { wpId ->
                                { month: LocalDate -> onCreateRosterForMonth(wpId, state.availableWorkplaceIds[wpId] ?: fallbackName, month.year, month.month.number) }
                            }
                        )
                    }
                } else {
                    items(state.activeRosters, key = { "active-${it.id}" }) { roster ->
                        Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                            // SH-161 F3: a right click (or the accessibility actions) opens the month in a new window.
                            ContextMenuArea(
                                items = { listOfNotNull(openInNewWindow?.let { open -> ContextMenuItem(newWindowLabel, { WindowTarget.forRoster(roster.id)?.let(open) }, Icons.AutoMirrored.Filled.OpenInNew) }) },
                                modifier = Modifier.fillMaxWidth(),
                                enabled = openInNewWindow != null
                            ) {
                            RegularCard(
                                modifier = Modifier.hoverLift(),
                                onClick = { onRosterSelected(roster) }
                            ) {
                                Column(modifier = Modifier.padding(16.dp)) {
                                    Row(
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Box(
                                            modifier = Modifier
                                                .size(40.dp)
                                                .clip(RoundedCornerShape(8.dp))
                                                .background(DeepNavy),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            Icon(Icons.Default.CalendarMonth, null, tint = Color.White)
                                        }
                                        Spacer(Modifier.width(16.dp))
                                        Column(modifier = Modifier.weight(1f)) {
                                            val monthLabel = monthName(roster.month)
                                            Text(
                                                "$monthLabel ${roster.year}",
                                                style = MaterialTheme.typography.titleMedium,
                                                fontWeight = FontWeight.Bold,
                                                color = DeepNavy
                                            )
                                            // SH-163: the status as a chip ("Wersja robocza"), without "Status:".
                                            Spacer(Modifier.height(4.dp))
                                            RosterStatusChip(roster.status)
                                            // SH-263: published, then changed: the team does not see the changes yet.
                                            if (roster.id in trackerState.unpublished) {
                                                Spacer(Modifier.height(4.dp))
                                                UnpublishedBadge()
                                            }
                                        }
                                        // SH-155: deleting is in the card's menu, not a red bin beside the month.
                                        if (state.capabilities.shows(Gate.ROSTER_EDITING)) {
                                            var menuOpen by remember { mutableStateOf(false) }
                                            Box {
                                                IconButtonWithTooltip(onClick = { menuOpen = true }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.roster_more_actions)) {
                                                    Icon(Icons.Default.MoreVert, contentDescription = stringResource(Res.string.roster_more_actions), tint = DeepNavy)
                                                }
                                                DropdownMenu(expanded = menuOpen, onDismissRequest = { menuOpen = false }) {
                                                    DropdownMenuItem(
                                                        text = { Text(stringResource(Res.string.roster_delete), color = MaterialTheme.colorScheme.error) },
                                                        leadingIcon = { Icon(Icons.Default.Delete, null, tint = MaterialTheme.colorScheme.error) },
                                                        onClick = {
                                                            menuOpen = false
                                                            rosterToDelete = roster
                                                        }
                                                    )
                                                }
                                            }
                                        }
                                        Icon(Icons.Default.ChevronRight, null, tint = DeepNavy)
                                    }

                                    // Capacity before planning (SH-48): demand, availability, who has not answered.
                                    // SH-155: a labelled button, not an unexplained people icon.
                                    if (state.capabilities.shows(Gate.CAPACITY) && (roster.status != RosterStatus.SKELETON || roster.availabilityRequestId != null)) {
                                        Spacer(Modifier.height(12.dp))
                                        // A tappable row like the card's other actions: title, what it shows, chevron.
                                        Button(
                                            onClick = { onOpenCapacity(roster) },
                                            modifier = Modifier.fillMaxWidth().handCursor(),
                                            shape = RoundedCornerShape(8.dp),
                                            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 10.dp),
                                            colors = ButtonDefaults.buttonColors(
                                                containerColor = DeepNavy.copy(alpha = 0.05f),
                                                contentColor = DeepNavy
                                            )
                                        ) {
                                            Icon(Icons.Default.Groups, null, modifier = Modifier.size(20.dp))
                                            Spacer(Modifier.width(12.dp))
                                            Column(Modifier.weight(1f)) {
                                                Text(
                                                    stringResource(Res.string.roster_card_capacity_title),
                                                    fontWeight = FontWeight.Bold,
                                                    maxLines = 1,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                                Text(
                                                    stringResource(Res.string.roster_card_capacity_action),
                                                    style = MaterialTheme.typography.bodySmall,
                                                    color = DeepNavy.copy(alpha = 0.7f)
                                                )
                                            }
                                            Icon(Icons.Default.ChevronRight, null, modifier = Modifier.size(20.dp))
                                        }
                                    }

                                    // SH-170: where the month stands (demand, availability, assignments,
                                    // publication) with its numbers and ONE button for the current step;
                                    // it took over SH-167's skeleton action.
                                    val progress = trackerState.progress[roster.id]
                                    if (progress != null && state.capabilities.shows(Gate.ROSTERS)) {
                                        Spacer(Modifier.height(12.dp))
                                        val editing = state.capabilities.shows(Gate.ROSTER_EDITING)
                                        val campaign = state.capabilities.shows(Gate.AVAILABILITY_CAMPAIGN)
                                        val reminderTitle = stringResource(Res.string.capacity_reminder_title)
                                        val reminderMessage = progress.deadline?.let {
                                            stringResource(Res.string.capacity_reminder_message_due, monthInSentence(roster.month), roster.year, dayAndMonth(it))
                                        } ?: stringResource(Res.string.capacity_reminder_message, monthInSentence(roster.month), roster.year)
                                        RosterTracker(
                                            progress = progress,
                                            reminded = roster.id in trackerState.reminded,
                                            actions = RosterTrackerActions(
                                                openSkeleton = { onRosterSelected(roster) }.takeIf { editing },
                                                requestAvailability = { rosterToRequestAvailability = roster }.takeIf { campaign },
                                                remind = { tracker?.remind(progress, reminderTitle, reminderMessage); Unit }.takeIf { campaign && tracker != null },
                                                openBuilder = { onRosterSelected(roster) }.takeIf { editing }
                                            )
                                        )
                                    }

                                    // Manager/Owner action: Request Availability
                                    if (state.capabilities.shows(Gate.AVAILABILITY_CAMPAIGN)) {
                                        // SH-167: the step that turns the month into a draft, one tap away
                                        // (SH-170: the tracker's button, or here without it).
                                        if (roster.status == RosterStatus.SKELETON && progress == null && state.capabilities.shows(Gate.ROSTER_EDITING)) {
                                            Spacer(Modifier.height(12.dp))
                                            Button(
                                                onClick = { onRosterSelected(roster) },
                                                modifier = Modifier.fillMaxWidth().handCursor(),
                                                colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White),
                                                shape = RoundedCornerShape(8.dp),
                                                contentPadding = PaddingValues(vertical = 8.dp)
                                            ) {
                                                Icon(Icons.Default.Layers, null, modifier = Modifier.size(18.dp))
                                                Spacer(Modifier.width(8.dp))
                                                Text(stringResource(Res.string.roster_skeleton_open_finish), fontWeight = FontWeight.Bold)
                                            }
                                        }
                                        if (roster.status == RosterStatus.SKELETON || roster.status == RosterStatus.DRAFT) {
                                            // SH-172: asked at any stage, before the demand too. The tracker's
                                            // buttons ask while that is on offer; otherwise asking (or changing
                                            // the request) stays one tap away.
                                            val trackerAsks = roster.availabilityRequestId == null && progress != null &&
                                                (progress.stage == RosterStage.AVAILABILITY || progress.availabilityAlongside == AvailabilityStep.NOT_ASKED)
                                            if (!trackerAsks) {
                                                Spacer(Modifier.height(4.dp))
                                                TextButton(
                                                    onClick = { rosterToRequestAvailability = roster },
                                                    modifier = Modifier.handCursor(),
                                                    contentPadding = PaddingValues(horizontal = 8.dp, vertical = 4.dp)
                                                ) {
                                                    Icon(
                                                        if (roster.availabilityRequestId == null) Icons.Default.EventAvailable else Icons.Default.EditCalendar,
                                                        null,
                                                        modifier = Modifier.size(18.dp),
                                                        tint = DeepNavy
                                                    )
                                                    Spacer(Modifier.width(8.dp))
                                                    Text(
                                                        stringResource(
                                                            if (roster.availabilityRequestId == null) Res.string.dashboard_request_availability
                                                            else Res.string.dashboard_change_availability_request
                                                        ),
                                                        fontWeight = FontWeight.Bold,
                                                        color = DeepNavy
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            }
                        }
                    }
                }

                item(key = "end-space", span = { GridItemSpan(maxLineSpan) }) { Spacer(Modifier.height(80.dp)) }
            }

            // An action's progress (a request sent, a roster deleted); the first load has the placeholders.
            LoadingOverlay(isLoading = state.isLoading && state.rostersKnown)
        }
    }
}

/** SH-247: how many month cards stand in for the rosters on their way. */
private const val ROSTER_PLACEHOLDERS = 3


@Composable
fun AvailabilityRequestDialog(
    roster: Roster,
    onDismiss: () -> Unit,
    onConfirm: (startDate: String, endDate: String, dueDate: String, message: String?, emailLinks: AvailabilityEmailLinks) -> Unit,
    /** Shown above the form, e.g. when the dialog closes the skeleton step (SH-69). */
    intro: String? = null,
    /** The dismiss button's label ("Later" after the skeleton step; "Cancel" otherwise). */
    dismissLabel: String? = null,
    isSending: Boolean = false,
    /** SH-172: shown first (the month to ask for, when the dialog chooses it). */
    header: (@Composable () -> Unit)? = null,
    /** SH-172: why the request cannot be sent for this month (confirm disabled); null: it can. */
    blockedReason: String? = null
) {
    val isModifying = roster.availabilityRequestId != null
    val dialogTitle =
        if (isModifying) stringResource(Res.string.dashboard_change_availability_request) else stringResource(
            Res.string.dashboard_request_availability
        )
    val monthLabel = monthName(roster.month)

    // Defaults: the whole month, answers due on the 20th of the month before.
    val firstDay = remember(roster.id) { LocalDate(roster.year, roster.month, 1) }
    // SH-172: keyed by the month, which the dialog may switch.
    var startDate by remember(roster.id) { mutableStateOf(firstDay.toString()) }
    var endDate by remember(roster.id) { mutableStateOf(firstDay.plus(DatePeriod(months = 1)).minus(DatePeriod(days = 1)).toString()) }
    var dueDate by remember(roster.id) { mutableStateOf(defaultDueDate(firstDay).toString()) }
    var dueTime by remember { mutableStateOf("23:59") }

    val defaultMessage = stringResource(Res.string.availability_default_message, monthLabel)
    var message by remember(roster.id) { mutableStateOf(defaultMessage) }
    // SH-173: also by e-mail, with a personal link to a web form (no app, no sign-in).
    var byEmail by remember(roster.id) { mutableStateOf(false) }
    var emailTo by remember(roster.id) { mutableStateOf(AvailabilityEmailLinks.WITHOUT_APP) }

    val start = parseIsoDate(startDate)
    val end = parseIsoDate(endDate)
    val due = parseIsoDate(dueDate)
    val time = parseClockTime(dueTime)
    // The period may be part of the month (SH-48), never outside it.
    val (startError, endError) = dayRangeErrors(start, end, roster.year, roster.month)
    val valid = validDayRange(start, end, roster.year, roster.month) != null && due != null && time != null && blockedReason == null

    EvoDialog(
        title = dialogTitle,
        subtitle = "$monthLabel ${roster.year}",
        icon = Icons.Default.EventAvailable,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(24.dp),
        confirm = DialogAction(
            if (isModifying) stringResource(Res.string.availability_save_changes) else stringResource(Res.string.availability_send_request),
            {
                if (valid) {
                    onConfirm(
                        start.toString(), end.toString(), "${due}T${time}:00Z", message.trim().ifBlank { null },
                        if (byEmail) emailTo else AvailabilityEmailLinks.NONE
                    )
                }
            },
            enabled = valid && !isSending,
            loading = isSending,
            icon = Icons.AutoMirrored.Filled.Send
        ),
        dismiss = DialogAction(dismissLabel ?: stringResource(Res.string.cancel), onDismiss, enabled = !isSending)
    ) {
        header?.invoke()
        intro?.let {
            Text(it, style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.85f))
        }
        blockedReason?.let {
            Text(it, style = MaterialTheme.typography.bodyMedium, color = LocalOnColours.current.warning, fontWeight = FontWeight.Bold)
        }
        DialogSection(stringResource(Res.string.availability_planning_period)) {
            // SH-166: typed or picked in the range picker, days of the roster's month only.
            EvoDateRangeField(
                start = startDate,
                end = endDate,
                onStartChange = { startDate = it },
                onEndChange = { endDate = it },
                startLabel = stringResource(Res.string.availability_start_date),
                endLabel = stringResource(Res.string.availability_end_date),
                pickerTitle = stringResource(Res.string.availability_planning_period),
                allowed = monthRange(roster.year, roster.month).let { it.start..it.endInclusive },
                missingYear = MissingYear.Of(roster.year),
                showErrors = true,
                startError = startError,
                endError = endError
            )
        }
        DialogSection(stringResource(Res.string.availability_deadline)) {
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                EvoDateField(
                    value = dueDate,
                    onValueChange = { dueDate = it },
                    label = stringResource(Res.string.availability_due_date),
                    showErrors = true,
                    missingYear = MissingYear.Upcoming,
                    modifier = Modifier.weight(3f)
                )
                EvoTimeField(
                    value = dueTime,
                    onValueChange = { dueTime = it },
                    label = stringResource(Res.string.availability_time),
                    placeholder = "23:59",
                    showErrors = true,
                    modifier = Modifier.weight(2f)
                )
            }
        }
        EvoTextField(
            value = message,
            onValueChange = { message = it },
            label = stringResource(Res.string.availability_message),
            singleLine = false,
            minLines = 3,
            imeAction = ImeAction.Default
        )
        Column(Modifier.testTag(AVAILABILITY_EMAIL_TAG)) {
            EvoCheckboxRow(
                checked = byEmail,
                onCheckedChange = { byEmail = it },
                label = stringResource(Res.string.availability_email_also),
                supporting = stringResource(Res.string.availability_email_hint),
                enabled = !isSending
            )
            if (byEmail) {
                EvoRadioGroup(
                    options = listOf(AvailabilityEmailLinks.WITHOUT_APP, AvailabilityEmailLinks.EVERYONE),
                    selected = emailTo,
                    onSelect = { emailTo = it },
                    optionLabel = {
                        stringResource(
                            if (it == AvailabilityEmailLinks.EVERYONE) Res.string.availability_email_everyone
                            else Res.string.availability_email_without_app
                        )
                    },
                    modifier = Modifier.padding(start = 24.dp)
                )
            }
        }
    }
}

/** SH-173: test tag of the request dialog's "Also send by e-mail" section. */
const val AVAILABILITY_EMAIL_TAG = "availability_request_email"

/**
 * The default deadline: the 20th of the month before; for a month that starts sooner (asked late,
 * SH-172: the current month or the next one), a week from today, never after the month's start.
 */
internal fun defaultDueDate(firstDay: LocalDate, today: LocalDate = AppClock.today()): LocalDate {
    val usual = firstDay.minus(DatePeriod(months = 1)).let { LocalDate(it.year, it.month, 20) }
    if (usual >= today) return usual
    val inAWeek = today.plus(DatePeriod(days = 7))
    return if (inAWeek < firstDay) inAWeek else maxOf(today, firstDay)
}

/** SH-172: test tags of the Rosters list's "ask for availability" and of its month switcher. */
object AvailabilityMonthTags {
    const val ENTRY = "rosters_request_availability"
    const val PREVIOUS = "availability_month_previous"
    const val NEXT = "availability_month_next"
    const val MONTH = "availability_month_label"
}

/**
 * SH-172: the availability request for any month from the current one on, chosen in the dialog
 * ("‹ Listopad 2026 ›"): a month without a roster says one will be created, empty; a published
 * month cannot be asked again. Starts on the first month from now on that nobody was asked for.
 */
@Composable
internal fun MonthAvailabilityRequestDialog(
    workplaceId: String,
    rosters: List<Roster>,
    onDismiss: () -> Unit,
    onConfirm: (year: Int, month: Int, startDate: String, endDate: String, dueDate: String, message: String?, emailLinks: AvailabilityEmailLinks) -> Unit,
    today: LocalDate = AppClock.today()
) {
    val first = LocalDate(today.year, today.month, 1)
    val byMonth = rosters.filter { it.workplaceId == workplaceId }.associateBy { it.year * 100 + it.month }
    fun key(d: LocalDate) = d.year * 100 + d.month.number
    var month by remember(workplaceId) {
        mutableStateOf(
            generateSequence(first) { it.plus(DatePeriod(months = 1)) }.take(24).firstOrNull { d ->
                val roster = byMonth[key(d)]
                roster == null || (roster.availabilityRequestId == null && (roster.status == RosterStatus.SKELETON || roster.status == RosterStatus.DRAFT))
            } ?: first.plus(DatePeriod(months = 1))
        )
    }
    val existing = byMonth[key(month)]
    val roster = existing ?: Roster(
        id = com.evoapps.evoshift.domain.model.RosterIds.of(workplaceId, month.year, month.month.number),
        workplaceId = workplaceId,
        month = month.month.number,
        year = month.year,
        status = RosterStatus.SKELETON,
        currentVersion = 0,
        metadata = com.evoapps.evoshift.domain.model.AuditMetadata(createdAt = "", createdBy = "")
    )
    val closed = existing != null && existing.status != RosterStatus.SKELETON && existing.status != RosterStatus.DRAFT
    AvailabilityRequestDialog(
        roster = roster,
        onDismiss = onDismiss,
        onConfirm = { start, end, due, message, emailLinks -> onConfirm(roster.year, roster.month, start, end, due, message, emailLinks) },
        intro = if (existing == null) stringResource(Res.string.availability_month_no_roster) else null,
        blockedReason = if (closed) stringResource(Res.string.availability_month_closed) else null,
        header = {
            DialogSection(stringResource(Res.string.availability_month)) {
                val label = "${monthName(month.month.number)} ${month.year}"
                Row(verticalAlignment = Alignment.CenterVertically) {
                    IconButtonWithTooltip(
                        onClick = { month = month.minus(DatePeriod(months = 1)) },
                        enabled = month > first,
                        modifier = Modifier.handCursor().testTag(AvailabilityMonthTags.PREVIOUS),
                        tooltip = stringResource(Res.string.roster_previous_month)
                    ) {
                        Icon(
                            Icons.AutoMirrored.Filled.KeyboardArrowLeft,
                            stringResource(Res.string.roster_previous_month),
                            tint = if (month > first) LightGold else Color.White.copy(alpha = 0.3f)
                        )
                    }
                    Text(
                        label,
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = Color.White,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.weight(1f).testTag(AvailabilityMonthTags.MONTH)
                    )
                    IconButtonWithTooltip(
                        onClick = { month = month.plus(DatePeriod(months = 1)) },
                        modifier = Modifier.handCursor().testTag(AvailabilityMonthTags.NEXT),
                        tooltip = stringResource(Res.string.roster_next_month)
                    ) {
                        Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, stringResource(Res.string.roster_next_month), tint = LightGold)
                    }
                }
            }
        }
    )
}

/**
 * SH-163: a roster card's status as a small chip ("Wersja robocza"). "Zapotrzebowanie" gets a
 * short note beside it ("zmiany bez osób"): new owners do not know the word yet.
 */
@Composable
internal fun RosterStatusChip(status: RosterStatus) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(
            Modifier
                .clip(RoundedCornerShape(6.dp))
                .background(DeepNavy.copy(alpha = 0.08f))
                .padding(horizontal = 8.dp, vertical = 2.dp)
        ) {
            Text(
                status.label(),
                style = MaterialTheme.typography.labelMedium,
                fontWeight = FontWeight.SemiBold,
                color = DeepNavy
            )
        }
        if (status == RosterStatus.SKELETON) {
            Spacer(Modifier.width(8.dp))
            Text(
                stringResource(Res.string.roster_status_skeleton_hint),
                style = MaterialTheme.typography.bodySmall,
                color = DeepNavy.copy(alpha = 0.7f)
            )
        }
    }
}

/** SH-167: the first month from next month on that has no roster yet (AppClock, the device's zone). */
internal fun nextMonthWithoutRoster(rosters: List<Roster>, today: LocalDate = AppClock.today()): LocalDate {
    val taken = rosters.map { it.year * 100 + it.month }.toSet()
    var month = LocalDate(today.year, today.month, 1).plus(DatePeriod(months = 1))
    while (month.year * 100 + month.month.number in taken) month = month.plus(DatePeriod(months = 1))
    return month
}


/** SH-167: test tag of the empty roster list's next step. */
const val EMPTY_ROSTERS_TAG = "rosters_empty"

/**
 * SH-167: no rosters yet: what to do next, not just grey text. "Create the roster for November
 * 2026" (the next month without one) and the three steps a month goes through.
 */
@Composable
private fun EmptyRosters(next: LocalDate, onCreate: ((LocalDate) -> Unit)?) {
    Column(
        Modifier.fillMaxWidth().padding(vertical = 8.dp).testTag(EMPTY_ROSTERS_TAG),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Text(
            stringResource(Res.string.dashboard_no_rosters),
            style = MaterialTheme.typography.bodyMedium,
            color = DeepNavy.copy(alpha = 0.7f)
        )
        if (onCreate != null) {
            Button(
                onClick = { onCreate(next) },
                modifier = Modifier.fillMaxWidth().handCursor(),
                shape = RoundedCornerShape(12.dp),
                contentPadding = PaddingValues(vertical = 14.dp),
                colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White)
            ) {
                Icon(Icons.Default.Add, null, modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(8.dp))
                Text(
                    stringResource(Res.string.roster_empty_create, "${monthInSentence(next.month.number)} ${next.year}"),
                    fontWeight = FontWeight.Bold
                )
            }
            Text(
                stringResource(Res.string.roster_empty_steps_title),
                style = MaterialTheme.typography.titleSmall,
                fontWeight = FontWeight.Bold,
                color = DeepNavy
            )
            listOf(
                Res.string.roster_empty_step_demand,
                Res.string.roster_empty_step_availability,
                Res.string.roster_empty_step_publish
            ).forEachIndexed { index, step ->
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        Modifier.size(28.dp).clip(CircleShape).background(DeepNavy.copy(alpha = 0.08f)),
                        contentAlignment = Alignment.Center
                    ) {
                        Text("${index + 1}", style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold, color = DeepNavy)
                    }
                    Spacer(Modifier.width(12.dp))
                    Text(stringResource(step), style = MaterialTheme.typography.bodyMedium, color = DeepNavy)
                }
            }
        }
    }
}
